import React, { Suspense, lazy } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { WhatsAppButton } from './components/ui/WhatsAppButton';
import { LanguageProvider } from './context/LanguageContext';
const IntroSection = lazy(() => import('./components/IntroSection').then(m => ({
  default: m.IntroSection
})));
const LocationSection = lazy(() => import('./components/LocationSection').then(m => ({
  default: m.LocationSection
})));
const QualitiesSection = lazy(() => import('./components/QualitiesSection').then(m => ({
  default: m.QualitiesSection
})));
const AmenitiesSection = lazy(() => import('./components/AmenitiesSection').then(m => ({
  default: m.AmenitiesSection
})));
const PhasesSection = lazy(() => import('./components/PhasesSection').then(m => ({
  default: m.PhasesSection
})));
const AvailabilitySection = lazy(() => import('./components/AvailabilitySection').then(m => ({
  default: m.AvailabilitySection
})));
const DeveloperSection = lazy(() => import('./components/DeveloperSection').then(m => ({
  default: m.DeveloperSection
})));
const ContactSection = lazy(() => import('./components/ContactSection').then(m => ({
  default: m.ContactSection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const SectionLoader = () => <div className="flex items-center justify-center py-24" data-id="element-0">
    <div className="w-8 h-8 border-4 border-navy/20 border-t-navy rounded-full animate-spin" data-id="element-1"></div>
  </div>;
export function App() {
  return <LanguageProvider data-id="element-2">
      <div className="min-h-screen bg-white overflow-x-hidden" data-id="element-3">
        <Navbar data-id="element-4" />
        <main data-id="element-5">
          <Hero data-id="element-6" />
          <Suspense fallback={<SectionLoader data-id="element-8" />} data-id="element-7">
            <IntroSection data-id="element-9" />
            <LocationSection data-id="element-10" />
            <QualitiesSection data-id="element-11" />
            <AmenitiesSection data-id="element-12" />
            <PhasesSection data-id="element-13" />
            <AvailabilitySection data-id="element-14" />
            <DeveloperSection data-id="element-15" />
            <ContactSection data-id="element-16" />
          </Suspense>
        </main>
        <Suspense fallback={null} data-id="element-17">
          <Footer data-id="element-18" />
        </Suspense>
        <WhatsAppButton data-id="element-19" />
      </div>
    </LanguageProvider>;
}